import { render, staticRenderFns } from "./WhatisDid.vue?vue&type=template&id=3b49ea15&scoped=true&"
import script from "./WhatisDid.vue?vue&type=script&lang=js&"
export * from "./WhatisDid.vue?vue&type=script&lang=js&"
import style0 from "./WhatisDid.vue?vue&type=style&index=0&id=3b49ea15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b49ea15",
  null
  
)

export default component.exports